/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";

import "./global/global.css";
import Header from "./global/components/Header";
import Larrow from "./assets/Larrow.png";
import BellIcon from "./assets/bellIcon.png";
import { useHistory, useLocation } from "react-router-dom";
import { apiFetch } from "../../utils/apiFetch";
import { connect } from "react-redux";
import PlanCards from "./global/components/PlanCards";
import SideBar from "./global/components/SideBar";
import useWindowSize from "./global/hooks/WindowResizer";
import MobileViewHeader from "./global/components/MobileViewHeader";
import ProductBenefitCard from "./global/components/ProductBenefitCard";
import { Button, FormControlLabel, Grid, makeStyles, Paper } from "@material-ui/core";
import CustomSwitch from "./global/components/CustomSwitch";
import ProfileDetailsFields, { profileToDraft, draftToProfile } from "./ProfileDetailsFields";

const AUTH_MODEL_NONE = 1;
const AUTH_MODEL_STAFF = 2;
const AUTH_MODEL_FREE_DEMO = 3;
const AUTH_MODEL_SUBSCRIBER = 4;

const mapStateToProps = () => ({});

const useStyles = makeStyles({
  featureSwitchContainer: {
    display: "flex",
    padding: "10px 0 10px 0",
    borderBottom: "1px solid #CCCCCC",
  },
  featureSwitch: {
    margin: "0px",
    display: "flex",
    alignItems: "center",
    marginRight: "30px",
  },
  featureSwitchLabel: {
    color: "#000000",
    fontSize: "16px",
    fontWeight: 400,
    letterSpacing: "-0.4px",
  },
  productHeading: {
    fontSize: "18px",
    fontWeight: 500,
    letterSpacing: "-0.4px",
    margin: 0,
    padding: 0,
    color: "#000000",
    textAlign: "left",
    marginTop: "20px",
    marginBottom: "16px",
    fontFamily: "lexend, sans-serif !important",
  },
});

const MyAccount = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const [myAccountData, setMyAccountData] = useState(null);
  const [error, setError] = useState(null);
  const [stripeError, setStripeError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [apiVersion, setApiVersion] = useState("");
  const [profileForm, setProfileForm] = useState(() => profileToDraft());
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [profileSaveError, setProfileSaveError] = useState(null);
  const [profileSaveSuccess, setProfileSaveSuccess] = useState(false);
  const [localPasswordUser, setLocalPasswordUser] = useState(null);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [passwordChangeError, setPasswordChangeError] = useState(null);
  const [passwordChangeSuccess, setPasswordChangeSuccess] = useState(false);

  const [conciergeAssistantEnabled, setConciergeAssistantEnabled] =
    useState(true);
  const [administratorEnabled, setAdministratorEnabled] = useState(true);

  const isMobileView = useWindowSize();
  const location = useLocation();

  const handleUpgradeClick = () => {
    console.log("handleUpgradeClick - getting stripe url");
    apiFetch(`${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/stripe_checkout`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setStripeError(false);
          console.log(result.checkout_url);
          window.location.href = result.checkout_url;
        },
        (error) => {
          setIsLoaded(false);
          setStripeError(error);
          // history.push("./");
        }
      );
  };

  const handleManagePlanClick = (isStaff) => {
    if (!isStaff) {
      console.log("handleManagePlanClick -- todo");
      apiFetch(`${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/stripe_portal`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            if (result && result.portal_url) {
              setStripeError(false);
              console.log(result.portal_url);
              window.location.href = result.portal_url;
            }
          },
          (error) => {
            console.log(error);
            setStripeError(true);
          }
        );
    } else {
      console.log("handleManagePlanClick -- staff so no-op");
    }
  };

  const handleStripeErrorModalClose = () => {
    setStripeError(false);
    // dispatch(clearDashboardError());
  };

  function capitalizeNames(str) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  useEffect(async () => {
    try {
      const result = await apiFetch(
        `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/myaccount`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then(
          (result) => {
            const accountInfo =
              result.accounts && result.accounts.accountInfo
                ? result.accounts.accountInfo[0] || {}
                : {};
            const user = result.user || {};
            setProfileForm(profileToDraft({
              ...user,
              ...accountInfo,
              address: accountInfo.address || user.address || "",
            }));
            setMyAccountData(result);
            setIsLoaded(true);
          },
          (error) => {
            setIsLoaded(false);
            setError(error);
            history.push("./");
          }
        );
    } catch (error) {
      setIsLoaded(false);
      setError(error);
      history.push("./");
    }
  }, []);

  useEffect(async () => {
    const result = await apiFetch(
      `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/version`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        setApiVersion(result.app_version);
      });
  }, []);

  useEffect(() => {
    let isActive = true;
    const loadPasswordUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        if (!isActive) return;
        const idTokenPayload =
          user &&
          user.signInUserSession &&
          user.signInUserSession.idToken &&
          user.signInUserSession.idToken.payload;
        if (!idTokenPayload || typeof idTokenPayload !== "object") return;
        const identityValue =
          idTokenPayload.identities !== undefined
            ? idTokenPayload.identities
            : user.attributes && user.attributes.identities;
        if (identityValue === undefined) {
          setLocalPasswordUser(user);
          return;
        }
        const identities =
          typeof identityValue === "string"
            ? JSON.parse(identityValue)
            : identityValue;
        if (Array.isArray(identities) && identities.length === 0) {
          setLocalPasswordUser(user);
        }
      } catch (error) {
        if (isActive) setLocalPasswordUser(null);
      }
    };
    loadPasswordUser();
    return () => {
      isActive = false;
    };
  }, []);

  const [isDetailsPage, setIsDetailsPage] = useState(true);

  const handleMyDetailsPage = () => {
    setIsDetailsPage(true);
  };

  const handleMyPlansPage = () => {
    setIsDetailsPage(false);
  };

  const clearProfileSaveState = () => {
    setProfileSaveError(null);
    setProfileSaveSuccess(false);
  };

  const handleProfileFieldChange = (field, value) => {
    setProfileForm((current) => ({ ...current, [field]: value }));
    clearProfileSaveState();
  };

  const handleSaveProfile = async (event) => {
    event.preventDefault();
    const { first_name, last_name, ...profile } = draftToProfile(profileForm);

    setIsSavingProfile(true);
    setProfileSaveError(null);
    setProfileSaveSuccess(false);
    try {
      const response = await apiFetch(
        `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/myaccount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fname: first_name,
            lname: last_name,
            ...profile,
          }),
        }
      );
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error || "Unable to save profile.");
      }
      setProfileSaveSuccess(true);
    } catch (error) {
      setProfileSaveError(error.message || "Unable to save profile.");
    } finally {
      setIsSavingProfile(false);
    }
  };

  const handlePasswordFieldChange = (field) => (event) => {
    const value = event.target.value;
    setPasswordForm((current) => ({ ...current, [field]: value }));
    setPasswordChangeError(null);
    setPasswordChangeSuccess(false);
  };

  const handlePasswordChange = async (event) => {
    event.preventDefault();
    setPasswordChangeError(null);
    setPasswordChangeSuccess(false);
    if (
      !passwordForm.currentPassword ||
      !passwordForm.newPassword ||
      !passwordForm.confirmPassword
    ) {
      setPasswordChangeError("Enter all password fields.");
      return;
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPasswordChangeError("New password and confirmation do not match.");
      return;
    }

    setIsChangingPassword(true);
    try {
      await Auth.currentSession();
      await Auth.changePassword(
        localPasswordUser,
        passwordForm.currentPassword,
        passwordForm.newPassword
      );
      setPasswordForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
      setPasswordChangeSuccess(true);
    } catch (error) {
      setPasswordChangeError(
        error && error.message ? error.message : "Unable to change password."
      );
    } finally {
      setIsChangingPassword(false);
    }
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (
    !isLoaded ||
    !myAccountData ||
    !myAccountData.accounts ||
    myAccountData.accounts.length === 0 ||
    !myAccountData.accounts.accountInfo
  ) {
    // return <div>Loading...</div>;
    return (
      <div className="myAcc-root">
        {/* {!isMobileView && <SideBar />} */}
        <div className="myAccount-root">
          <div className="myAccount-content-container">
            {/* {!isMobileView && (
              <div className="backAndSave">
                <img src={Larrow} alt="backBtn" className="backArrow" />
              </div>
            )} */}

            {/* {isMobileView && <MobileViewHeader />} */}
          </div>

          <h1 style={{ color: "black" }} className="loading">
            Loading...
          </h1>
        </div>
      </div>
    );
  } else {
    const { accountInfo } = myAccountData.accounts;
    const fullName = `${profileForm.first_name} ${profileForm.last_name}`.trim();
    const displayname =
      fullName.length > 0 ? capitalizeNames(fullName) + "'s" : "My";
    const authLevel = accountInfo[0] && accountInfo[0].auth_model;
    const isStaff =
      accountInfo[0] && accountInfo[0].auth_model === AUTH_MODEL_STAFF;
    const freeReportsRemaining = accountInfo[0] && accountInfo[0].free_reports;

    return (
      <div className="myAcc-root">
        {/* {!isMobileView && <SideBar />} */}
        <div className="myAccount-root">
          <div className="myAccount-content-container">
            {/* {!isMobileView && (
              <div className="backAndSave">
                <img src={Larrow} alt="backBtn" className="backArrow" />
              </div>
            )}

            {isMobileView && <MobileViewHeader />} */}

            <div className="profile-name">
              <h1 className="name">{displayname}</h1>
              <p className="welcome">Welcome to your profile</p>
            </div>

            <div className="pageBar">
              <p
                className={`pb ${
                  isDetailsPage ? "myDetails activeTab" : "myDetails"
                }`}
                onClick={handleMyDetailsPage}
              >
                My Details
              </p>
              <p
                className={`pb ${
                  !isDetailsPage ? "myPlan activeTab" : "myPlan"
                }`}
                onClick={handleMyPlansPage}
              >
                Products
              </p>
            </div>

            {isDetailsPage && (
              <form className="profile-form" onSubmit={handleSaveProfile}>
                <ProfileDetailsFields
                  draft={profileForm}
                  email={accountInfo[0].email}
                  onChange={handleProfileFieldChange}
                  disabled={isSavingProfile}
                />
                {profileSaveError && <p role="alert">{profileSaveError}</p>}
                {profileSaveSuccess && <p role="status">Profile updated.</p>}
                <Button type="submit" variant="contained" color="primary" disabled={isSavingProfile}>
                  {isSavingProfile ? "Saving..." : "Save changes"}
                </Button>
              </form>
            )}

            {isDetailsPage && localPasswordUser && (
              <form onSubmit={handlePasswordChange} style={{ color: "#000" }}>
                <p className={classes.productHeading}>Change password</p>
                <div className="myDetails-page">
                  <div className="detail-box">
                    <label htmlFor="profile-current-password">Current password</label>
                    <input
                      id="profile-current-password"
                      type="password"
                      className="profileInputBox"
                      autoComplete="current-password"
                      value={passwordForm.currentPassword}
                      disabled={isChangingPassword}
                      required
                      onChange={handlePasswordFieldChange("currentPassword")}
                    />
                  </div>
                  <div className="detail-box">
                    <label htmlFor="profile-new-password">New password</label>
                    <input
                      id="profile-new-password"
                      type="password"
                      className="profileInputBox"
                      autoComplete="new-password"
                      value={passwordForm.newPassword}
                      disabled={isChangingPassword}
                      required
                      onChange={handlePasswordFieldChange("newPassword")}
                    />
                  </div>
                </div>
                <div className="myDetails-page">
                  <div className="detail-box">
                    <label htmlFor="profile-confirm-password">Confirm new password</label>
                    <input
                      id="profile-confirm-password"
                      type="password"
                      className="profileInputBox"
                      autoComplete="new-password"
                      value={passwordForm.confirmPassword}
                      disabled={isChangingPassword}
                      required
                      onChange={handlePasswordFieldChange("confirmPassword")}
                    />
                  </div>
                </div>
                {passwordChangeError && <p role="alert">{passwordChangeError}</p>}
                {passwordChangeSuccess && <p role="status">Password updated.</p>}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isChangingPassword}
                >
                  {isChangingPassword ? "Changing password..." : "Change password"}
                </Button>
              </form>
            )}

            {!isDetailsPage && (
              <>
                <div className={classes.featureSwitchContainer}>
                  <span className={classes.featureSwitch}>
                    <CustomSwitch
                      checked={conciergeAssistantEnabled}
                      onChange={(e) =>
                        setConciergeAssistantEnabled(e.target.checked)
                      }
                    />
                    <span className={classes.featureSwitchLabel}>
                      Deal Program Manager
                    </span>
                  </span>
                  <span className={classes.featureSwitch}>
                    <CustomSwitch
                      checked={administratorEnabled}
                      onChange={(e) =>
                        setAdministratorEnabled(e.target.checked)
                      }
                    />
                    <span className={classes.featureSwitchLabel}>
                      Administrator
                    </span>
                  </span>
                </div>

                {/* <div className="plan-cards">
                  <PlanCards
                    title="Basic"
                    description="Get started with ease — list a couple of properties and explore our platform at no cost."
                    price="Free"
                    duration="Forever Free"
                    features={[
                      "List up to 2 properties",
                      "Access to basic support",
                      "Visibility on search",
                      "Email notifications",
                    ]}
                    isHighlighted={false}
                  />
                  <PlanCards
                    title="Pro"
                    description="Get started with ease — list a couple of properties and explore our platform at no cost."
                    price="$40"
                    duration="per month"
                    features={[
                      "List up to 2 properties",
                      "Access to basic support",
                      "Visibility on search",
                      "Email notifications",
                    ]}
                    isHighlighted={true}
                    onClickFunction={handleUpgradeClick}
                  />

                  <PlanCards
                    title="Premium"
                    description="Get started with ease — list a couple of properties and explore our platform at no cost."
                    price="$90"
                    duration="per month"
                    features={[
                      "List up to 2 properties",
                      "Access to basic support",
                      "Visibility on search",
                      "Email notifications",
                    ]}
                    isHighlighted={false}
                  />
                </div> */}
                <p className={classes.productHeading}>Deal Program Manager</p>
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    <ProductBenefitCard
                      title={"Deal Document Creation"}
                      description={
                        "Automatically generates customized purchase agreements and information sheets from email requests."
                      }
                      status={"Enabled"}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <ProductBenefitCard
                      title={"Deal Coordination"}
                      description={
                        "Manages deal milestones and tracks progress from contract to closing with automated updates."
                      }
                      status={"Enabled"}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <ProductBenefitCard
                      title={"Deal Closing"}
                      description={
                        "Streamlines the closing process with automated document tracking and deadline management."
                      }
                      status={"Enabled"}
                    />
                  </Grid>
                </Grid>
                <p className={classes.productHeading}>Administrator</p>
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    <ProductBenefitCard
                      title={"Property Tax Payments"}
                      description={
                        "Ensure timely property tax payments with automated reminders."
                      }
                      status={"Limited"}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <ProductBenefitCard
                      title={"Utility Payments"}
                      description={
                        "Help clients manage utility transfers and payments during moving process."
                      }
                      status={"Limited"}
                    />
                  </Grid>
                </Grid>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
};

// export default MyAccount;

export default connect(mapStateToProps)(MyAccount);
